import request from '@/utils/request'

//抢购-秒杀

export const finishTask = (data) => {
    return request({
        method: "POST",
        url: "/task/finishTask",
        data

    })
}